export const SIGNALR_SERVER_TIMEOUT_MS = 2500;
export const SIGNALR_KEEP_ALIVE_INTERVAL_MS = 2000;
